<script>
	const config = {
  // ...
  onwarn: (warning, handler) => {
    if (warning.code === 'a11y-click-events-have-key-events') return
    handler(warning)
  },
}

	import Queue from "./components/Queue.svelte";
    import WhoIsLoggedIn from "./components/WhoIsLoggedIn.svelte";
	import SearchBox from "./components/SearchBox.svelte";
	import Playing from "./components/Playing.svelte";
	import Footer from "./components/Footer.svelte";

	import { detectIncognito } from "detectincognitojs";

	let incognito = true;
	detectIncognito().then((result) => {
  		//console.log(result.browserName, result.isPrivate);
		incognito = result.isPrivate
});

</script>

<main>
	<WhoIsLoggedIn />
	<Playing />
	{#if !incognito}
	<div class="content">
		<SearchBox />
		<Queue />
	</div>
	{:else}
		<p style="text-align: center">Adding and voting for songs are blocked in private mode.</p>
	{/if}
	<Footer />
</main>

<style>
	.content {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

@media only screen and (max-width: 600px) {
  .content {
    grid-template-rows: auto 1fr;
	grid-template-columns: 1fr;
  }
}
</style>